// extracted by mini-css-extract-plugin
module.exports = {"root":"BmiRanges_root__28YnF","ranges":"BmiRanges_ranges__KrCf7"};